"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
var ExternalLink = /** @class */ (function () {
    function ExternalLink(links) {
        this.ctaClassName = 'cta';
        this.ctaWithIconClassName = 'cta--with-icon';
        if (links) {
            this.links = links;
        }
    }
    ExternalLink.prototype.checkLinks = function () {
        var _this = this;
        this.links.forEach(function (link) {
            var isExternal = _this.isExternal(link);
            if (isExternal) {
                _this.insertIcon(link);
            }
        });
    };
    ExternalLink.prototype.isExternal = function (link) {
        try {
            var href = link.getAttribute('href');
            var isVideoButton = link.classList.contains('cta-video');
            var isEmailLink = href.indexOf('mailto:') > -1;
            var isPhoneLink = href.indexOf('tel:') > -1;
            if (!href || isVideoButton || isEmailLink || isPhoneLink) {
                return false;
            }
            return new URL(href).origin !== location.origin;
        }
        catch (e) {
            return false;
        }
    };
    ExternalLink.prototype.insertIcon = function (element) {
        var content = element.querySelector('.cta-content');
        if (element.querySelector('.icon')) {
            return;
        }
        if (!content) {
            element.appendChild(this.createIconElement());
            return;
        }
        if (element.classList.contains(this.ctaClassName) &&
            !element.classList.contains(this.ctaWithIconClassName)) {
            element.classList.add(this.ctaWithIconClassName);
        }
        content.appendChild(this.createIconElement());
    };
    ExternalLink.prototype.createIconElement = function () {
        var span = document.createElement('span');
        span.classList.add('icon', 'icon-external-link');
        return span;
    };
    return ExternalLink;
}());
exports.ExternalLink = ExternalLink;
